"use strict";

require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findEqual = exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.array.concat.js");
var _formElements = require("@evidation/form-elements");
var _utils = require("../../utils");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactSelect = _interopRequireDefault(require("react-select"));
var _lodash = _interopRequireDefault(require("lodash"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _utils2 = require("../../components/utils");
var _useTranslated = require("../../hooks/useTranslated");
var _clsx = _interopRequireDefault(require("clsx"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Container = _styledComponents["default"].div.withConfig({
  displayName: "selectAdvanced__Container"
})(["margin-bottom:8px;.react-select__control{border-radius:0;border:", ";border-bottom:", ";}"], function (props) {
  return props.inputStyle === "sm_minimal" ? "0" : "1px solid #ccc";
}, function (props) {
  return props.inputStyle === "sm_minimal" ? "1px solid #E6E6E6" : "1px solid #ccc";
});
var OptionLabel = _styledComponents["default"].span.withConfig({
  displayName: "selectAdvanced__OptionLabel"
})(["p{margin:0 !important;}"]);
var SafeProps = ["addLabelText", 'aria-describedby', 'aria-label', 'aria-labelledby', "arrowRenderer", "autoBlur", "autofocus", "autosize", "backspaceRemoves", "backspaceToRemoveMessage", "className", "clearAllText", "clearRenderer", "clearValueText", "clearable", "deleteRemoves", "delimiter", "escapeClearsValue", "filterOption", "filterOptions", "ignoreAccents", "ignoreCase", "inputProps", "inputRenderer", "instanceId", "isLoading", "joinValues", "labelKey", "matchPos", "matchProp", "menuBuffer", "menuContainerStyle", "menuRenderer", "menuStyle", "isMulti", "name", "noResultsText", "onBlurResetsInput", "onChange", "onClose", "onCloseResetsInput", "onFocus", "onInputChange", "onInputKeyDown", "onMenuScrollToBottom", "onOpen", "onValueClick", "openAfterFocus", "openOnFocus", "optionClassName", "optionComponent", "optionRenderer", "options", "pageSize", "placeholder", "required", "resetValue", "scrollMenuIntoView", "searchable", "simpleValue", "style", "tabIndex", "tabSelectsValue", "valueComponent", "valueKey", "valueRenderer", "wrapperStyle"];
var findEqual = exports.findEqual = function findEqual(options) {
  return function (item) {
    return _lodash["default"].find(options, function (o) {
      return _lodash["default"].isString(o) ? _lodash["default"].isEqual(item, o) : _lodash["default"].isEqual(item, o.value);
    });
  };
};
var SelectAdvanced = function SelectAdvanced(props) {
  var error = props.error,
    required = props.required,
    label = props.label,
    labelStyle = props.labelStyle,
    inputStyle = props.inputStyle,
    name = props.name,
    valueFromProps = props.value,
    optionsFromProps = props.options,
    config = props.config,
    initialValue = props.initialValue,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    description = props.description,
    is_multi_select = props.is_multi_select,
    labelTooltip = props.labelTooltip,
    _onChange = props.onChange,
    _props$containerProps = props.containerProps,
    containerProps = _props$containerProps === void 0 ? {} : _props$containerProps,
    schemaHasHeading = props.schemaHasHeading,
    hint_text = props.hint_text,
    numberOfInputs = props.numberOfInputs;
  var options = (0, _utils.generateOptionsListFromArrayOrObjectArray)(optionsFromProps);
  var placeholderSingle = (0, _useTranslated.useTranslated)('components.selectAdvanced.placeholderSingle');
  var placeholderMultiple = (0, _useTranslated.useTranslated)('components.selectAdvanced.placeholderMultiple');
  var FindItemInOptions = findEqual(options);
  // covering the case where the output is an array
  // this can ocurr if it is a multi select
  var getValueFromOption = function getValueFromOption(opt) {
    return _lodash["default"].isArray(opt) ? _lodash["default"].map(opt, function (item) {
      return item === null || item === void 0 ? void 0 : item.value;
    }) : opt === null || opt === void 0 ? void 0 : opt.value;
  };

  // covering the case where the output is an array
  // this can ocurr if it is a multi select
  var value = _lodash["default"].isArray(valueFromProps) ? _lodash["default"].map(valueFromProps, function (item) {
    return FindItemInOptions(item);
  }) : FindItemInOptions(valueFromProps);
  (0, _react.useEffect)(function () {
    if (_lodash["default"].isUndefined(value) && !_lodash["default"].isUndefined(initialValue)) {
      _onChange(getValueFromOption(initialValue));
    }
  }, [initialValue, _onChange, value]);
  return /*#__PURE__*/_react["default"].createElement("div", null, !schemaHasHeading && numberOfInputs === 1 ? /*#__PURE__*/_react["default"].createElement(_formElements.AccessibleLegend, {
    schemaHasHeading: schemaHasHeading,
    numberOfInputs: numberOfInputs
  }, (0, _utils.stripHtml)(label)) : /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: name,
    className: "basic-label"
  }, (0, _utils.stripHtml)(label)), /*#__PURE__*/_react["default"].createElement(Container, (0, _extends2["default"])({
    inputStyle: inputStyle,
    "data-test": "select-advanced"
  }, containerProps), hint_text ? /*#__PURE__*/_react["default"].createElement(_formElements.HintText, {
    text: hint_text,
    id: "".concat(name, "_hint")
  }) : null, /*#__PURE__*/_react["default"].createElement("div", {
    role: "alert"
  }, error.length !== 0 && /*#__PURE__*/_react["default"].createElement(_formElements.InputError, {
    id: "t-".concat(name, "_error-message_"),
    style: {
      visibility: error.length !== 0 ? 'visibile' : 'hidden'
    }
  }, error)), !is_multi_select ? /*#__PURE__*/_react["default"].createElement("select", {
    value: valueFromProps !== undefined || valueFromProps !== null ? isNaN(valueFromProps) ? valueFromProps : Number(valueFromProps) : '',
    name: name,
    id: name,
    "aria-invalid": error.length !== 0,
    "aria-required": required,
    "aria-errormessage": error.length !== 0 ? error : undefined,
    onChange: function onChange(evt) {
      return _onChange(evt.target.value);
    },
    disabled: disabled,
    required: required,
    className: (0, _clsx["default"])('evi-select--basic', error.length !== 0 && 'evi-error--border'),
    "aria-describedby": "".concat(hint_text ? "".concat(name, "_hint") : '')
  }, /*#__PURE__*/_react["default"].createElement("option", {
    value: ""
  }, placeholderSingle), options.map(function (option, id) {
    return /*#__PURE__*/_react["default"].createElement("option", {
      value: option.value,
      key: "".concat(name, "_opt_").concat(id),
      disabled: option.disabled
    }, (0, _utils.stripHtml)(option.label));
  })) : /*#__PURE__*/_react["default"].createElement(_reactSelect["default"], (0, _extends2["default"])({}, _lodash["default"].pick(props, SafeProps), {
    classNamePrefix: "react-select",
    onChange: function onChange(opt) {
      var selectedValue = getValueFromOption(opt);
      _onChange(selectedValue);
      // Allowing watching for changes without overriding the onChange handler.
      if (props.watch && typeof props.watch === 'function') {
        props.watch(name, selectedValue);
      }
    }
  }, config, {
    options: options,
    value: value,
    inputId: name,
    defaultValue: initialValue,
    isDisabled: disabled,
    placeholder: is_multi_select ? placeholderMultiple : placeholderSingle,
    isClearable: true,
    formatOptionLabel: function formatOptionLabel(data) {
      return /*#__PURE__*/_react["default"].createElement(OptionLabel, {
        dangerouslySetInnerHTML: {
          __html: (0, _utils.sanitizeHTML)(data.label)
        }
      });
    },
    classNames: {
      control: function control() {
        return error.length !== 0 ? 'evi-error--border' : '';
      }
    },
    "aria-invalid": error.length !== 0,
    "aria-errormessage": "".concat(name, "_error_message"),
    "arial-required": required,
    isMulti: is_multi_select
  }))));
};
SelectAdvanced.propTypes = {
  name: _propTypes["default"].string,
  label: _propTypes["default"].string,
  labelStyle: _propTypes["default"].oneOf(["light", "dark", "darker", "gray", "black", "achievement"]),
  inputStyle: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  options: _propTypes["default"].array.isRequired,
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array]),
  style: _propTypes["default"].object,
  error: _propTypes["default"].string,
  simpleValue: _propTypes["default"].bool,
  autoBlur: _propTypes["default"].bool,
  config: _propTypes["default"].object
};
SelectAdvanced.defaultProps = {
  name: "select_dropdown",
  onChange: function onChange() {
    return false;
  },
  onBlur: function onBlur() {
    return true;
  },
  inputStyle: "achievement",
  labelStyle: "dark",
  simpleValue: true,
  autoBlur: false,
  required: false,
  style: {},
  error: "",
  disabled: false,
  placeholder: "",
  className: "",
  isSearchable: true,
  config: {}
};
var FilterProps = function FilterProps(props) {
  return /*#__PURE__*/_react["default"].createElement(SelectAdvanced, (0, _utils2.util_commonInputParamters)(props));
};
FilterProps.handlesErrorDisplay = true;
FilterProps.showWarningIconOnError = false;
var _default = exports["default"] = FilterProps;